<div *transloco='let transl' class="info-row" data-testid="visit-id-name">
  <div>
    {{ transl('visit.menu.welcome_vv_text')}}
  </div>
</div>
<mat-divider></mat-divider>
